<template>
    <div>
        <div class="content-caption dashed">基础信息</div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>发起人</label>
                </div>
                <div class="form-value width-2x">
                    <span>{{comUserInfo.name || ''}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>发起部门</label>
                </div>
                <div class="form-value width-2x">
                    <el-select v-model="departId" placeholder="请选择">
                        <el-option v-for="item in comUserInfo.departs" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
        </div>
        <!--<div class="content-caption dashed">配置信息</div-->
        <template v-if="bizVoucherId != null">
            <div class="content-caption dashed">附件信息</div>
            <div class="file-area1 clearfix">
                <div class="file-item1 deletable viewable downloadable editable">
                    <div class="file-icon">
                        <i class="file-type-icon doc small"></i>
                    </div>
                    <div class="file-content">
                        <p class="file-name" v-if="bizTypeCode == 'retailer.assets.purch'">请购单据明细.xlsx</p>
                        <p class="file-name" v-if="bizTypeCode == 'retailer.assets.allot'">调拨单据明细.xlsx</p>
                        <p class="file-name" v-if="bizTypeCode == 'retailer.assets.scrap'">报废单据明细.xlsx</p>
                        <p class="file-name" v-if="bizTypeCode == 'retailer.assets.clear'">清除单据明细.xlsx</p>
                        <!--<p class="file-time">2021-07-26 13:55</p>-->
                    </div>
                    <div class="file-opera">
                        <!--<i class="icon iconfont icon-chakan view"></i>-->
                        <i class="icon iconfont icon-xiazai download" @click="dowmloadFile()"></i>
                        <!--<i class="icon iconfont icon-bianji edit"></i>-->
                        <!--<i class="delete-icon"></i>-->
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'

    import oaAuditApi from '../../api/oaAudit'

    export default {
        name: 'swb-ding-ding-audit-view',
        desc: '钉钉审批预览',
        props: {
            bizVoucherId: {
                type: Number,
                default: null
            },
            bizVoucherNo: {
                type: String,
                default: null
            },
            bizTypeCode: {
                type: String,
                default: null
            },
        },
        data: function () {
            return {
                comUserInfo: [],
                departId: null,
            }
        },
        created: function () {
            this.getDingDingUserDetail();
        },
//    {
//        "id" : "3564693832912929",
//        "unionId" : "8MwDTCe9lH5S6R0ldxZEAQiEiE",
//        "name" : "胡长伟",
//        "title" : "",
//        "avatar" : "https://static-legacy.dingtalk.com/media/lADPDgQ9qa0kswjNAqTNAqo_682_676.jpg",
//        "departIds" : [ 587830918 ],
//        "departs" : [ {
//        "id" : 587830918,
//        "name" : "资产管理部"
//    } ]
//    }
        methods: {
            getDingDingUserDetail: function () {
                let self = this;
                let params = {};
                let theLoad = MsgBox.loading();
                oaAuditApi.getDingDingUserDetail(params, function (result) {
                    theLoad.hide();
                    if (result.type === "info") {
                        self.comUserInfo = result.data || [];
                        //
                        self.departId = self.comUserInfo.departs[0].id;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            dowmloadFile: function () {
                let self = this;
                let theDownloadUrl = Utils.makeUrl(getAppUrl('/api/oa/audit/dingding/biz/voucher/detail/download'), {
                    voucherId: self.bizVoucherId,
                    bizTypeCode: self.bizTypeCode
                });
                Utils.setPageUrl(theDownloadUrl, '_blank');
            },
            getDlgResult: function () {
                let result = {
                    type: 'info',
                };
                if (Utils.isNoB(this.departId)) {
                    result.type = 'warn';
                    result.message = '请选择发起人部门';
                }
                result.data = {
                    userId: this.comUserInfo.id,
                    departId: this.departId
                };
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/oaAudit/DingDingAuditView.vue